import { render } from "./Rodape.vue?vue&type=template&id=40955a4a&scoped=true"
import script from "./Rodape.vue?vue&type=script&lang=js"
export * from "./Rodape.vue?vue&type=script&lang=js"

import "./Rodape.vue?vue&type=style&index=0&id=40955a4a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40955a4a"]])

export default __exports__